import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { useFeatures } from '../contexts/FeaturesContext';

/**
 * Blocks lab/personal routes unless the signed-in user has the required feature flag.
 */
export default function FeatureGuard({ feature, children }) {
  const { hasFeature, loading } = useFeatures();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!feature || hasFeature(feature)) {
    return children;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50vh',
        px: 2,
        textAlign: 'center',
      }}
    >
      <Typography variant="h5" gutterBottom>
        Not available
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, maxWidth: 420 }}>
        This section isn&apos;t part of the public Lifestack launch yet. Core features — lists, meals, recipes, and
        chores — are on your dashboard.
      </Typography>
      <Button component={Link} to="/" variant="contained" startIcon={<HomeIcon />}>
        Back to Home
      </Button>
    </Box>
  );
}
